import { P as Pagination } from './pagination-BYB1eQGc.js';
import { S as Swiper } from './index-1rH35xIi.js';
import './classes-to-selector-B0Ehowsi.js';
import './create-element-if-not-defined-CpMCDYSa.js';
import './swiper-core-ClzX336E.js';
import './a11y-BJABkpRI.js';

class HeroBanner extends HTMLElement {
  connectedCallback() {
    this.swiper = Swiper(this, {
      modules: [Pagination],
      spaceBetween: 0,
      slidesPerView: 1,
      autoplay: {
        delay: 200,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
        bulletElement: 'button',
      },
    });
  }
}

customElements.define('hero-banner', HeroBanner);
